import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { LlScrollpaneService } from '../ll-scrollpane.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlModelsService } from '../ll-models.service';

@Component({
  selector: 'll-model-cash-switch',
  templateUrl: './ll-model-cash-switch.component.html',
  styleUrl: './ll-model-cash-switch.component.css'
})
export class LlModelCashSwitchComponent {

  @ViewChild('mainDiv_ll_model_cash_switch') mainDiv: ElementRef;
  /*@ViewChild('horzTabs_ll_model_cash_switch') public horzTabs: ElementRef;*/

  constructor(
    private LlScrollpaneService: LlScrollpaneService,
    private LlPermissionsService: LlPermissionsService,
    private LlModelsService: LlModelsService,
  ) { }

  bundle = {
    showHorzTabs: false,
    showRemaining: false,
    mode:'',
    function: '',
    LlScrollpaneService: this.LlScrollpaneService,
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 20,
    remainingW: 0,
    remainingH: 0,
    showTab: true,
    horzTabsY: 20,
    hTabW: 120,
    hTabH: 15,
    hTabIndent: 50,
    hTabIndx: 0,
    horzTabs: [],
    horzTabs_02: [],
    canvasHT: {},
    ctxHT: {},
    activeCODE: "List",
  }

  ngOnInit() { }

  eventSubscription_ll_model_cash_switch: any;

  ngOnDestroy() {
    this.eventSubscription_ll_model_cash_switch.unsubscribe();
  }

  ngAfterViewInit() {


    this.eventSubscription_ll_model_cash_switch = this.LlModelsService.ll_model_cash_switch.subscribe(action => {
      this.bundle.mode = action;
    });

    this.setVars();
  }

  setVars() {
    this.bundle.showHorzTabs = false;
    this.bundle.showRemaining = false;

    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.remainingX = 0;
      this.bundle.remainingY = this.bundle.horzTabsY + this.bundle.hTabH + 3
      this.bundle.remainingW = this.bundle.parentW;;
      this.bundle.remainingH = this.bundle.parentH - this.bundle.remainingY;

      //var canvasHT: HTMLCanvasElement = this.horzTabs.nativeElement;
      //this.bundle.canvasHT = canvasHT
      //this.bundle.ctxHT = canvasHT.getContext('2d');

      this.getData()
    });
  }

  getData() {

    this.bundle.horzTabs.splice(0);
    if (this.LlPermissionsService.check("canUpLoadBankFiles")) {
      this.bundle.horzTabs.push({ LABEL: "Bank-Cash-Uploads" });
    }

    this.bundle.horzTabs.push({ LABEL: "Bank-Cash-Lists" });
    this.bundle.horzTabs.push({ LABEL: "Bank-Cash-Rules" });

    if (this.LlPermissionsService.check("canEditBankAccounts")) {
      this.bundle.horzTabs.push({ LABEL: "Bank-Accounts" });
    }
    if (this.LlPermissionsService.check("reconcileCash")) {
      this.bundle.horzTabs.push({ LABEL: "Remit-Cash-Reconcile" });
    }
    if (this.LlPermissionsService.check("canViewCashProjctn")) { 
      this.bundle.horzTabs.push({ LABEL: "Cash-Projection" });
    }

    this.bundle.activeCODE = this.bundle.horzTabs[0].LABEL;

   // this.LlScrollpaneService.paintHorzTab(horzTabSelected, this.bundle.horzTabs, this.bundle.canvasHT, this.bundle.ctxHT, this.bundle, false);

    function horzTabSelected(indx, bundle) {
      bundle.mode = ''
    }

    this.bundle.showHorzTabs = true;
    this.bundle.showRemaining = true;

  }

  selectTab(code) {

    this.bundle.showRemaining = false;

    this.bundle.activeCODE = code;

    /////console.log("this.bundle.activeCODE: " + this.bundle.activeCODE )

    setTimeout(() => {
      this.bundle.showRemaining = true;
    },100);
  }

  clearMode() {
    this.bundle.mode = '';
  }

}
